import { useState } from 'react'
import { Button } from '@cloudflare/kumo'
import type { RecentGuest } from '@hub-wifi/shared'
import { useTranslation } from '../../i18n'
import { RecentGuestChips } from './RecentGuestChips'
import '../home/home.css'

export const COLLAPSED_COUNT = 4

/** Recent guests as links to the pre-filled form: the first few, "Show all (N)" for the rest. */
export function RecentGuestsList({ guests }: { guests: RecentGuest[] }) {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)
  const hidden = guests.length - COLLAPSED_COUNT

  return (
    <div className="flex flex-col gap-2">
      <RecentGuestChips
        guests={expanded ? guests : guests.slice(0, COLLAPSED_COUNT)}
        wrap={expanded}
      />
      {hidden > 0 && (
        <div>
          <Button variant="ghost" aria-expanded={expanded} onClick={() => setExpanded((e) => !e)}>
            {expanded
              ? t('guestInvitations.recent.showFewer')
              : t('guestInvitations.recent.showAll', { count: guests.length })}
          </Button>
        </div>
      )}
    </div>
  )
}
